const sanitizePhoneNumber = (phoneNumber: string) =>
  phoneNumber.replace(/\(/g, '').replace(/\)/g, '').replace(/-/g, '').replace(/\s/g, '');

export default sanitizePhoneNumber;
